import {useEffect, useState} from "react"
import {createPortal} from "react-dom"
import {get_or_append} from "../dom_utils"

function Portal({id, children}) {
  const [element, set_element] = useState()

  useEffect(() => {
    set_element(get_or_append(id))
  }, [element, id])

  if (!element) return

  return createPortal(children, element)
}

export default Portal
